import { useEffect, useState } from 'react';

import { ColumnFiltersState, SortingState } from '@tanstack/react-table';

import { Pagination } from 'components/common/pagination/customPagination';

interface IUseReactTableStateProps {
    initialPagination?: Pagination;
    initialSorting?: SortingState;
    initialColumnOrder?: string[];
}
export type TUseReactTableState = ReturnType<typeof useReactTableState>;

export const useReactTableState = ({
    initialPagination = { page: 1, size: 50 },
    initialSorting = [],
    initialColumnOrder = [],
}: Partial<IUseReactTableStateProps> = {}) => {
    const [pagination, setPagination] = useState<Pagination>(initialPagination);
    const [sorting, setSorting] = useState<SortingState>(initialSorting);
    const [columnVisibility, setColumnVisibility] = useState({}); //TODO: add proper type
    const [columnOrder, setColumnOrder] = useState<string[]>(initialColumnOrder);
    const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
    const [rowSelection, setRowSelection] = useState({});

    return {
        pagination,
        setPagination,
        sorting,
        setSorting,
        columnVisibility,
        setColumnVisibility,
        columnOrder,
        setColumnOrder,
        columnFilters,
        setColumnFilters,
        rowSelection,
        setRowSelection,
    };
};
